import React from "react";
import { Shell } from "./Shell";
import { useLang } from "../i18n";
import { useAuth } from "../api";
import { ASSETS } from "../assets";

export const studentNav = (t, grade) => {
  const young = (Number(grade) || 3) <= 4;
  const items = [
    { key: "home", to: "/student", label: t("dashboard"), icon: ASSETS.progress },
    { key: "journey", to: "/student/journey", label: "الخريطة", icon: ASSETS.games },
    { key: "chat", to: "/student/chat", label: "حوار AI", icon: ASSETS.tutor },
    { key: "quiz", to: "/student/quiz", label: t("quiz"), icon: ASSETS.quiz },
    { key: "dictionary", to: "/student/dictionary", label: t("dictionary"), icon: ASSETS.dictionary },
    { key: "tasks", to: "/student/tasks", label: t("myTasks"), icon: ASSETS.tasks },
    { key: "practice", to: "/student/practice", label: t("writing"), icon: ASSETS.tasks },
    { key: "competitions", to: "/student/competitions", label: t("competitions"), icon: ASSETS.quiz },
    { key: "leaderboard", to: "/student/leaderboard", label: t("leaderboard"), icon: ASSETS.progress },
  ];
  return young ? items.filter((i) => !["competitions"].includes(i.key)) : items;
};

export const ownerNav = (t) => [
  { key: "dashboard", to: "/owner", label: t("dashboard"), icon: ASSETS.progress },
];

export const staffNav = (t, role) => ({
  school_admin: [{ key: "dashboard", to: "/school", label: t("dashboard"), icon: ASSETS.progress }],
  teacher: [{ key: "dashboard", to: "/teacher", label: t("myClasses"), icon: ASSETS.topics }],
}[role] || []);

export const StudentShell = ({ children, right }) => {
  const { t } = useLang();
  const { user } = useAuth();
  return <Shell nav={studentNav(t, user?.grade)} variant="play" right={right}>{children}</Shell>;
};
